/**
 * 管理员后台布局壳 — 深色侧栏 + 图标分组
 */
import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import {
  ChartBarIcon, UsersIcon, ShoppingCartIcon, CubeIcon,
  CpuChipIcon, DocumentTextIcon, WrenchIcon, Cog6ToothIcon, SwatchIcon,
} from '@heroicons/react/24/outline';

const groups = [
  {
    label: '概览',
    items: [{ to: '/admin', label: '统计总览', icon: ChartBarIcon, end: true }],
  },
  {
    label: '用户与订单',
    items: [
      { to: '/admin/users', label: '用户管理', icon: UsersIcon },
      { to: '/admin/orders', label: '订单管理', icon: ShoppingCartIcon },
      { to: '/admin/plans', label: '套餐管理', icon: CubeIcon },
    ],
  },
  {
    label: 'AI 配置',
    items: [
      { to: '/admin/models', label: '模型管理', icon: CpuChipIcon },
      { to: '/admin/prompts', label: '提示词管理', icon: DocumentTextIcon },
      { to: '/admin/skills', label: '技能管理', icon: WrenchIcon },
      { to: '/admin/diagram-styles', label: '图表风格', icon: SwatchIcon },
    ],
  },
  {
    label: '系统',
    items: [{ to: '/admin/settings', label: '系统设置', icon: Cog6ToothIcon }],
  },
];

const AdminLayout: React.FC = () => (
  <div className="h-screen overflow-hidden flex">
    <aside className="w-60 bg-slate-800 text-white flex flex-col flex-shrink-0">
      <div className="px-5 py-4 border-b border-slate-700">
        <h1 className="text-base font-bold tracking-tight">小灵标 · 后台</h1>
        <p className="text-xs text-slate-400 mt-0.5">Management Console</p>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-5 overflow-y-auto">
        {groups.map(g => (
          <div key={g.label}>
            <div className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider px-3 mb-1.5">
              {g.label}
            </div>
            {g.items.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors mb-0.5 ${
                    isActive
                      ? 'bg-indigo-600 text-white'
                      : 'text-slate-300 hover:bg-slate-700 hover:text-white'
                  }`
                }
              >
                <item.icon className="w-4 h-4 flex-shrink-0" />
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
      <div className="px-5 py-3 border-t border-slate-700 text-xs text-slate-500">
        小灵标 v1.0
      </div>
    </aside>
    <main className="flex-1 bg-slate-50 p-6 overflow-y-auto">
      <Outlet />
    </main>
  </div>
);

export default AdminLayout;
